import React, { useState, useEffect } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import Time from '@/components/ReactTime/ReactTime';
import Caret from '/public/svg/pbs-dropdown-triangle.svg';
import styles from '@/components/MultiLivestream/Schedule/Timeline.module.scss';
type MultiLivestreamTimelineProps = {
  scheduleTimes: Array<Dayjs>;
  secondaryTimezone?: string | null;
  now: Dayjs;
};
const MultiLivestreamTimeline = (props: MultiLivestreamTimelineProps) => {
  const {
    scheduleTimes,
    secondaryTimezone,
    now
  } = props;
  const [timingIndicatorColumnStart, setTimingIndicatorColumnStart] = useState(1);
  const [timingIndicatorOffset, setTimingIndicatorOffset] = useState(`0`);

  // Determines how much of the first half hour is past
  // in order to display the moving time indicator at the correct location.
  // (As the schedule updates, this indicator will only ever appear in the first
  // half hour of the timeline)
  useEffect(() => {
    if (scheduleTimes?.length > 0) {
      const minutesIntoSchedule = now.diff(scheduleTimes[0], 'minute');
      // at the start and end of the 30 minute chunk we need to translate
      // the timing indicator so it looks right
      if (minutesIntoSchedule === 0) {
        setTimingIndicatorColumnStart(1);
        setTimingIndicatorOffset('-50%');
      } else if (minutesIntoSchedule === 29) {
        setTimingIndicatorColumnStart(28);
        setTimingIndicatorOffset('50%');
        // this case doesn't come up often - if we're 30 minutes in,
        // we're usually flipped over to the next half hour at 0 minutes into the schedule
      } else if (minutesIntoSchedule === 30) {
        setTimingIndicatorColumnStart(28);
        setTimingIndicatorOffset('75%');
      } else {
        // the majority use case
        setTimingIndicatorColumnStart(minutesIntoSchedule);
        setTimingIndicatorOffset('0');
      }
    }
  }, [now, scheduleTimes]);
  return <div className={styles.multi_livestream__schedule__timeline} data-sentry-component="MultiLivestreamTimeline" data-sentry-source-file="Timeline.tsx">
      <div className={`${styles.time_slot} ${styles.time_slot__day}`} aria-hidden="true">
        {dayjs(now).format('ddd M/D')}
      </div>
      {scheduleTimes.map((scheduleTime, index) => {
      return <span className={styles.time_slot} key={`timeslot-${index + 1}`}>
            <Time dateTime={scheduleTime.format()} secondaryTimezone={secondaryTimezone ? secondaryTimezone : null} format="LT" />
            {index === 0 && <Caret className={styles.time_indicator} data-testid="time-indicator" style={{
          gridColumnStart: timingIndicatorColumnStart,
          translate: timingIndicatorOffset
        }} />}
          </span>;
    })}
    </div>;
};
export default MultiLivestreamTimeline;